<template>
  <a-modal v-model="visible" title="移动项目" width="600px" :confirmLoading="loading" @ok="submit">
    <a-form-model class="edp-form" layout="vertical" ref="form" :rules="rules" :model="form">
      <a-form-model-item label="任务">
        <a-input :value="`${task.seqid}/${task.code}`" disabled></a-input>

      </a-form-model-item>
      <div class="line-2">
        <a-form-model-item prop="prjoid" label="项目">
          <a-select showSearch optionFilterProp="children" allowClear v-model="form.prjoid" @change="onChangePrj()">
            <a-select-option v-for="item in projectList" :key="item.oid" :value="item.oid">
              {{ item.project_name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item prop="phase_oid" label="阶段">
          <a-select allowClear :disabled="!form.prjoid" v-model="form.phase_oid">
            <a-select-option v-for="item in phaseList" :key="item.oid" :value="item.oid">
              {{ item.phase_name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </div>
    </a-form-model>
  </a-modal>
</template>

<script>
import {fetch} from "@/utils/request";

export default {
  emits: ['reload'],
  data() {
    return {
      loading: false,
      visible: false,
      projectList: [],
      phaseList: [],
      rules: {
        prjoid: [{required: true, message: '请选择项目'}],
        phase_oid: [{required: true, message: '请选择阶段'}],
      },
      task: {
        oid: "",
        seqid: "",
        code: ""
      },
      form: {
        prjoid: "",
        phase_oid: ""
      }
    }
  },
  methods: {
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true
          fetch("post", "prj/issue/childrenoid", {
            oid: this.task.oid
          }).then(res => {
            if (res.status === 0) {
              return fetch("post", "prj/issue/mutimove", {
                ...this.form,
                oid: res.data
              }).then((res) => {
                if (res.status === 0) {
                  this.$message.success("移动成功")
                } else {
                  this.$message.error(res.message)
                }
                this.visible = false
                this.$emit('reload')
              })
            } else {
              this.$message.error(res.message)
            }
          }).finally(() => this.loading = false)
        }
      })
    },
    open(issue) {
      this.task.oid = issue.oid
      this.task.code = issue.issue_code
      this.task.seqid = issue.seqid
      this.visible = true
      this.$nextTick(() => {
        this.$refs.form?.resetFields()
      })
      if (this.projectList.length === 0) {
        this.getProjectList()
      }
    },
    onChangePrj() {
      if (!this.form.prjoid) return;
      this.getPhaseList()
      this.form.phase_oid = ""
    },
    getPhaseList() {
      fetch("post", "/prj/phase/retrieve", {
        page_size: 999,
        prjoid: this.form.prjoid
      }).then(res => {
        if (res.status === 0) {
          this.phaseList = res.data.datas
        }
      })
    },
    getProjectList() {
      fetch("post", "/prj/retrieve").then(res => {
        if (res.status === 0) {
          this.projectList = res.data.datas
        }
      })
    },
  }
}
</script>